import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import Square3Stack3dSvg from '@/assets/Square3Stack3d.svg';

const Square3Stack3d = ({ size, variant, className }: IconProps) => (
  <img
    src={Square3Stack3dSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default Square3Stack3d;
